<template>
  <div class="">
    <router-view></router-view>
  </div>
</template>
<script>
  export default {
    created(){
      this.$auth.load().then(() => {
        if(this.$auth.check())
          this.$router.replace({ name: 'index' })
      })
    }
  }
</script>
